import { FORM_SUBMISSION_ERROR } from '../constants/general';
import { IHistory } from '../interfaces';
import { UserModel } from '../model/UserModel';
import { getSignatureData, showAlert } from '../utils/generalUtils';
import { put, putCustom, getCustom, postCustom } from '../utils/HTTP';
import { getUser } from './userService';
import { saveNotifications } from '../actions/summaryActions';
import { format } from 'date-fns'; 

export async function getOrganizationMfa(company: string) {
    try {
        const response = await getCustom(`/OrganizationMFA/${company}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching org MFA:', error);
        return { success: false, isMfaEnabled: true };
    }
}

export async function updateOrganizationMfa(company: string, isMfaEnabled: boolean) {
    try {
        const response = await postCustom('/OrganizationMFA', { company, isMfaEnabled });
        return response.data;
    } catch (error) {
        console.error('Error updating org MFA:', error);
        throw error;
    }
}

export async function updateUserProfile(submittedValues: { groups: string; email: any; firstName: any; password: any; jobDesc: any; jobTitle: any; lastName: any; middleName: any; userId: string; accessLevel: any; signatureUrl: any, originalEmail: any, locationName: any }, history: IHistory, phoneNumber: any, signature: string | File) {
    const groupNames = submittedValues.groups ? submittedValues.groups.split(',') : [];
    const data = {
        email: submittedValues.email,
        originalEmail: submittedValues.originalEmail,
        firstName: submittedValues.firstName,
        password: submittedValues.password,
        groups: (groupNames.length > 0 ? groupNames : []),
        jobDesc: submittedValues.jobDesc,
        jobTitle: submittedValues.jobTitle,
        lastName: submittedValues.lastName,
        middleName: submittedValues.middleName || '',
        userId: submittedValues.userId,
        phoneNumber: phoneNumber || '',
        accessLevel: submittedValues.accessLevel,
        signatureUrl: submittedValues.signatureUrl || '',
        locationName: submittedValues.locationName || '',
        dateCreated: format(new Date(), 'yyyy-MM-dd'),
        company: UserModel.getCompanyName(), signatureData: (signature && getSignatureData(signature, 'signatures') ) || null,
    };
    try { 
        const response = await putCustom('/CreateUser', data);  
        if (JSON.stringify(response.data).indexOf('error') > 0) {
            showAlert(FORM_SUBMISSION_ERROR, 'profile', 'danger');
            return;
        }
        await getUser(submittedValues.userId);
        //updateUserData(submittedValues.userId); Replicated in await getUser()
        showAlert(response.data.message, 'profile-modal', 'success',
            async () => { 
                history.push('/home'); 
            });
    } catch (error) {
        showAlert(FORM_SUBMISSION_ERROR, 'profile', 'danger');
        throw error;
    }
}

export async function getNotifications(userId: string, companyName: string) {
    try {
        const response = await getCustom(`/Notifications/${UserModel.getCompanyName()}/${userId}/long`);
        saveNotifications(response.data.data, response.data.totalFollowupOpen);
    } catch (error) {
        throw error;
    }
}

export async function setNotificationsSeen(uniqueId: string, userUID: string, companyName: string) {
    try {
        await put('/Notifications', {
            notifications: [{ 
                uniqueId: uniqueId,
                seen: true
            }]
        });
        await getNotifications(userUID, companyName);
    } catch (error) {
        throw error;
    }
}
